document.addEventListener('DOMContentLoaded', () => {

    const header = document.querySelector('.header');

    (function headerWatcher() {
        if (window.scrollY < 10) {
            header.classList.remove('header--bg')
        } else {
            header.classList.add('header--bg')
        }
        requestAnimationFrame(headerWatcher)
    })()

    function scrollToTarget(selector) {
        const target = document.querySelector(selector)
        if (target) {
            const headerHeight = 100
            const targetPosition = target.getBoundingClientRect().top
            const offsetPosition = parseInt(targetPosition + window.scrollY - headerHeight)
            const k = (offsetPosition > window.scrollY) ? -1000 : 1000;

            gsap.to(window, {
                scrollTo: { y: offsetPosition + k },
                duration: .5,
                ease: 'linear',
                onComplete: () => {
                    const targetPosition = target.getBoundingClientRect().top
                    const offsetPosition = parseInt(targetPosition + window.scrollY - headerHeight)
                    gsap.to(window, {
                        scrollTo: { y: offsetPosition },
                        duration: .5,
                        ease: 'linear'
                    });
                }
            });
        } else {
            console.warn(`Элемент "${selector}" не найден!`)
        }
    }

    // Menu Scroll
    const linklist = document.querySelectorAll('.header__nav-link, .mobile-menu__nav-link')
    linklist.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            closeMobMenu()
            const target = e.target.getAttribute('href')
            scrollToTarget(target)
        })
    })

    const mmBtn = document.querySelector('.header__menu-btn')

    mmBtn.addEventListener('click', () => {
        if (document.body.classList.contains('mm-open')) {
            closeMobMenu()
        }
        else {
            openMobMenu()
        }
    })

    const openMobMenu = () => {
        document.body.classList.add('mm-open')
        setTimeout(() => {
            document.body.classList.add('mm-opened')
        }, 10);
    }
    const closeMobMenu = () => {
        document.body.classList.remove('mm-opened')
        setTimeout(() => {
            document.body.classList.remove('mm-open')
        }, 300);
    }
})